import { Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent } from 'rxjs';
import { MatDialog } from '@angular/material';

import { IdleModalComponent } from './../components/modal/idle-modal/idle-modal.component';

import { AppSettings } from '../app.settings';

@Injectable()
export class IdleService {

	// User's current status: active / idling
	public status: BehaviorSubject<'active' | 'idling' | 'timeout'> = new BehaviorSubject(null);
	// Mousedown event
	private mousedown$;
	// Timeout for the time that activate status lasts
	private activateTimeout;
	// Time interval for automatically updating activeTimeout
	private autoSetActiveInterval;
	constructor(
		private dialog: MatDialog
	) { }

	initIdleMonitor() {
		console.log('Init idle monitor');
		// Set 'active' as initial status
		this.status.next('active');
		// Listen for mousedown event on document and set status active
		this.mousedown$ = fromEvent(document, 'mousedown');
		this.mousedown$.subscribe(() => {
			if (this.status.getValue() === 'active') {
				this.setActive();
			}
		});
	}
	clearActiveTimeout() {
		console.log('Stop Idle Monitor');
		clearTimeout(this.activateTimeout);
	}
	// Set current status active and reset timeout
	setActive() {
		console.log('user active. re-count before idle.');
		// Clear timeout if it exists already
		if (this.activateTimeout) {
			clearTimeout(this.activateTimeout);
		}
		// Set new timeout for active status
		this.activateTimeout = setTimeout(() => {
			this.status.next('idling');
		}, AppSettings.idleTime);
	}
	// Automatically renew timeout. This is used for long service call processing
	autoSetActive() {
		// Clear interval if it exists already
		if (this.autoSetActiveInterval) {
			clearInterval(this.autoSetActiveInterval);
		}
		// Set active
		if (this.status.getValue() === 'active') {
			this.setActive();
		}
		this.autoSetActiveInterval = setInterval(() => {
			if (this.status.getValue() === 'active') {
				this.setActive();
			}
		}, AppSettings.idleTime - 10000);
	}
	// Stop automatically renew
	stopAutoSetActive() {
		if (this.autoSetActive) {
			clearInterval(this.autoSetActiveInterval);
		}
	}
	// Open Idle window
	openIdleWindow(successCallback?) {
		const dialogRef = this.dialog.open(IdleModalComponent, {
			width: '300px'
		});
		dialogRef.afterClosed().subscribe((rsp) => {
			if (successCallback) { successCallback(rsp); }
		});
	}
}
